import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DisplayLineItem from '../common/DisplayLineItem';

class AddFeedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedback: props.feedback,
      isEditing: props.index === 0,
    };
    this.handleAddFeedback = this.handleAddFeedback.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDeleteFeedback = this.handleDeleteFeedback.bind(this);
  }

  handleInputChange(event) {
    const { category, id, updateLineItemFeedback } = this.props;
    updateLineItemFeedback(category, id, event.target.value);
    this.setState({ feedback: event.target.value });
  }

  handleAddFeedback() {
    this.setState({ isEditing: true });
    const { category, id, updateLineItemFeedback } = this.props;
    updateLineItemFeedback(category, id, null);
  }

  handleDeleteFeedback() {
    const { category, id, updateLineItemFeedback } = this.props;
    updateLineItemFeedback(category, id, null);
    this.setState({ feedback: null, isEditing: false });
  }

  render() {
    const { index, id } = this.props;
    const { isEditing, feedback } = this.state;
    return (
      <div className="full-width with-add-feedback">
        <div className="g-row--always">
          <DisplayLineItem
            {...this.props}
            feedback={feedback}
            showFeedback={!isEditing}
          />
          {!isEditing
            && (
            <div
              tabIndex={0}
              role="button"
              className="add-feedback g-row--always mt-3"
              onClick={() => this.handleAddFeedback()}
            >
              {feedback ? 'Edit' : <i className="fa fa-edit" />}
            </div>
            )}
        </div>
        {isEditing
          && (
          <div className={`feedback-row g-row--always ${index % 2 === 1 ? 'even-row' : null}`}>
            <div className="g-flex-fill">
              <div className="body-text-2 medium-weight mb-5">
                <i className="fa fa-edit" />
                Request edits on this line:
              </div>
              <textarea
                value={feedback}
                className="form-control"
                placeholder="Why the consultant should modify this line item?
                Type particular comments here..."
                name="feedback"
                id={`feedback-${id}`}
                rows="2"
                onChange={this.handleInputChange}
              />
            </div>
            <div className="g-row g-row--centered mt-5 ms-3">
              <a
                tabIndex={0}
                role="button"
                className="delete-feedback"
                onClick={this.handleDeleteFeedback}
              >
                <i className="fa fa-trash-alt mt-6" />
              </a>
            </div>
          </div>
          )}
      </div>
    );
  }
}

AddFeedback.propTypes = {
  index: PropTypes.number.isRequired,
  feedback: PropTypes.string,
  category: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  updateLineItemFeedback: PropTypes.func.isRequired,
};

AddFeedback.defaultProps = {
  feedback: null,
};

export default AddFeedback;
